import { createFeatureSelector, createSelector } from '@ngrx/store';
import { IOnboardingState } from './advisor-onboarding.state';

export const selectOnboardingState = createFeatureSelector<IOnboardingState>('ADVISOR-ONBOARDING');

export const OnboardingSelectors = {
  selectIsLoading: createSelector(
    selectOnboardingState,
    (state: IOnboardingState) => state?.isLoading ?? false,
  ),
  selectError: createSelector(
    selectOnboardingState,
    (state: IOnboardingState) => state?.error ?? null,
  ),
  selectOnboardings: createSelector(
    selectOnboardingState,
    (state: IOnboardingState) => state?.onboardings ?? [],
  ),
  selectTotalCount: createSelector(
    selectOnboardingState,
    (state: IOnboardingState) => state?.totalCount ?? 0,
  ),
  selectCurrentPage: createSelector(
    selectOnboardingState,
    (state: IOnboardingState) => state?.currentPage ?? 1,
  ),
  selectPageSize: createSelector(
    selectOnboardingState,
    (state: IOnboardingState) => state?.filters?.PageSize ?? 10,
  ),
  selectFilters: createSelector(
    selectOnboardingState,
    (state: IOnboardingState) => state?.filters ?? {},
  ),
  selectActiveFiltersCount: createSelector(selectOnboardingState, (state: IOnboardingState) => {
    if (!state?.filters) return 0;
    const filters = state.filters;
    let count = 0;
    if (filters.Search && filters.Search !== '') count++;
    if (filters.FirstName && filters.FirstName !== '') count++;
    if (filters.LastName && filters.LastName !== '') count++;
    if (filters.CrmNumber && filters.CrmNumber !== '') count++;
    if (filters.IdentityOrPassport && filters.IdentityOrPassport !== '') count++;
    return count;
  }),
};
